<template>
  <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm" :size="formSize"
    status-icon>
    <el-form-item label="职业名称" prop="roleName">
      <el-input v-model="ruleForm.roleName" />
    </el-form-item>
    <el-form-item label="试刷题数量" prop="trialNum">
      <el-input v-model="ruleForm.trialNum" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="default" @click="submitForm(ruleFormRef)">
        保存
      </el-button>
      <el-button size="default" @click="closeForm">关闭</el-button>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { reactive, ref, defineEmits, defineExpose } from "vue";
import { ElMessage } from "element-plus";
import { roleSaveOrUpdate } from "@/http/http";
const formSize = ref("default");
const emit = defineEmits(["dialogClose"]);
const ruleFormRef = ref();
const ruleForm = reactive({
  roleName: "",
  trialNum: 10
});

const rules = reactive({
  roleName: [
    {
      required: true,
      message: "请输入职业名称",
      trigger: ["change", "blur"],
    },
  ],
  trialNum: [
    {
      required: true,
      message: "请输入试刷题数量",
      trigger: ["change", "blur"],
    },
  ],
});

const init = (row) => {
  for (const key in row) {
    ruleForm[key] = row[key];
  }
};
defineExpose({ init });

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log(ruleForm);
      
      roleSaveOrUpdate(ruleForm).then((res) => {
        if (res.data.code == 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          emit("dialogClose", true);
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

const closeForm = () => {
  emit("dialogClose");
};
</script>
